<template>
  <div class="modal-bg">
    <div class="modal-title">
      MODAL CALENDAR
    </div>
    <DatePicker
      v-model="singleDate"
      :columns="1"
      color="gray"
      :attributes="attrs"
      class="date-picker"
      @click.stop=""
    />
    <div class="date-holder">
      <div class="date-display">
        <div class="label">
          date
        </div>
        <div class="date-bg">
          <div class="date">
            {{ showDate(singleDate) }}
          </div>
          <div class="weekday">
            {{ showWeekday(singleDate) }}
          </div>
        </div>
      </div>
      <div class="save">
        SAVE
      </div>
    </div>
  </div>
</template>

<script>


import 'v-calendar/dist/style.css';
import { useRMTStore } from '@/store/RMTStore';
import { DatePicker } from 'v-calendar';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
dayjs.locale('en');
import weekday from 'dayjs/plugin/weekday';
import { storeToRefs } from 'pinia/dist/pinia';


dayjs.extend(weekday);

export default {
  name: 'ModalCalendar',
  components: {
    DatePicker
  },
  setup () {
    const RMTStore = useRMTStore();
    const { singleDate } = storeToRefs(RMTStore);
    return {
      RMTStore, singleDate
    };
  },
  data () {
    return {
      date: new Date(),
      attrs: [
        {
          highlight: {
            start: { fillMode: 'outline' },
            base: { fillMode: 'light' },
            end: { fillMode: 'outline' },
          },
          dates: { start: new Date(2019, 0, 14), end: new Date(2019, 0, 18) },
        },
      ],
    };
  },
  methods: {
    showWeekday (d) {
      return dayjs(d).format('dddd');
    },
    showDate (d) {
      return dayjs(d).format('MMM D, YYYY');
    }
  }
};
</script>

<style scoped>
.date-picker  {
  width: 100%;
  padding: 50px;
  font-family: "Heebo", sans-serif;
}
.label {
  font-size: .75em;
  font-weight: 700;
}
.date-bg {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  background-color: lightgrey;
}
.date {
  font-weight: 700;
  font-size: .85em;
}
.weekday {
  font-size: .85em;
}
.date-holder {
  display: flex;
  align-items: end;
  justify-content: end;
  padding-right: 50px;
}
.save {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: green;
  color: white;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 14px;
  padding-bottom: 14px;
  font-weight: 700;
  cursor: pointer;
}
</style>

<style>
.vc-container {
  border: none;
}
.vc-day {
  min-height: 45px;
}
.vc-highlight {
  min-height: 45px;
  width: 45px;
}
span.vc-day-content.vc-focusable {
  background-color: transparent;
}
</style>